// Las hojas de estilo de terceros van primero para que las nuestras
// puedan sobrescribirlas sin necesidad de !important.
import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";
import "./index.css";

import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { StyledEngineProvider, ThemeProvider } from "@mui/material/styles";
import { store } from "./Redux/Store";
import { theme } from "./theme";
import {
  AuthenticationResult,
  EventMessage,
  EventType,
  PublicClientApplication,
} from "@azure/msal-browser";
import { msalConfig } from "./authConfig";
export const msalInstance = new PublicClientApplication(msalConfig);

// Si hay varias cuentas de Microsoft guardadas (p. ej. una personal o de otra
// empresa además de la de AEDAS), se prefiere la del tenant de AEDAS: con la
// primera que saliera se podía pedir el acceso con una cuenta que el backend
// no reconoce.
const aedasTenantId = msalConfig.auth.authority?.split("/").pop();
if (!msalInstance.getActiveAccount()) {
  const accounts = msalInstance.getAllAccounts();
  const account = accounts.find((a) => a.tenantId === aedasTenantId) ?? accounts[0];
  if (account) {
    msalInstance.setActiveAccount(account);
  }
}

msalInstance.addEventCallback((event: EventMessage) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
    const payload = event.payload as AuthenticationResult;
    const account = payload.account;
    msalInstance.setActiveAccount(account);
  }
});
ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        {/* injectFirst: los estilos de MUI se insertan antes que nuestro CSS */}
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={theme}>
            <App pca={msalInstance} />
          </ThemeProvider>
        </StyledEngineProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);
